import React, { useEffect, useState } from "react";
import { Button, Placeholder, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faGlobe } from "@fortawesome/free-solid-svg-icons";

import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import { toast } from "react-toastify";

const SupplierList = ({ workspaceId, setSelectedSupplier, setPopupShow, reload }) => {
  const [supplierList, setSupplierList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.supplierStock.SUPPLIERS,
          type: "GET",
          query: { workspace: workspaceId },
        });
        setLoading(false);
        setSupplierList(response.data || []);
      } catch (error) {
        setLoading(false);
        console.log("Failed to fetch suppliers:", error.message);
      }
    };

    setLoading(true);
    fetchSuppliers();
  }, [workspaceId, reload]);

  const handleEdit = (supplier) => {
    setSelectedSupplier(supplier);
    setPopupShow(true);
  };

  const handleDelete = async (supplierId) => {
    if (window.confirm("Bạn có chắc muốn xoá supplier này? Dữ liệu stock liên quan cũng sẽ bị xoá.")) {
      try {
        const res = await Utils._apiRequest({
          path: `${Enums.endpoints.supplierStock.SUPPLIERS}/${supplierId}`,
          type: "DELETE",
        });
        if (res.errors) throw new Error(res.errors);
        toast.success("Xoá supplier thành công");
        setSupplierList(supplierList.filter((s) => s._id !== supplierId));
      } catch (error) {
        toast.error(error.message || "Lỗi khi xoá supplier");
      }
    }
  };

  return (
    <OverlayScrollbarsComponent
      style={{ maxWidth: "100%" }}
      options={{ scrollbars: { autoHide: "scroll" } }}
    >
      <Table striped hover className="table-text-inline supplier-stock-table">
        <thead>
          <tr>
            <th style={{ width: 20 }}>#</th>
            <th>Tên</th>
            <th>Website</th>
            <th>Ghi chú</th>
            <th>Người tạo</th>
            <th style={{ width: 140 }} className="text-end">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <>
              {[...Array(5).keys()].map((i) => (
                <tr key={i} className="placeholder-group">
                  <td>{i + 1}</td>
                  <td><Placeholder animation="glow"><Placeholder xs={10} /></Placeholder></td>
                  <td><Placeholder animation="glow"><Placeholder xs={8} /></Placeholder></td>
                  <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                  <td><Placeholder animation="glow"><Placeholder xs={8} /></Placeholder></td>
                  <td className="text-end"><Button size="sm" disabled variant="secondary"></Button></td>
                </tr>
              ))}
            </>
          ) : (
            <>
              {supplierList && supplierList.length > 0 ? (
                supplierList.map((supplier, i) => {
                  const displayName = supplier.owner?.fullName || supplier.owner?.email || "Unknown";
                  const initial = displayName.charAt(0).toUpperCase();
                  const bgColor = Utils.stringToColor(displayName);

                  return (
                    <tr key={supplier._id || i}>
                      <td>{i + 1}</td>
                      <td><strong>{supplier.name}</strong></td>
                      <td>
                        {supplier.website ? (
                          <a href={supplier.website} target="_blank" rel="noopener noreferrer" className="supplier-stock-table__website-link">
                            <FontAwesomeIcon icon={faGlobe} className="me-1" />
                            {supplier.website.replace(/^https?:\/\//, "").slice(0, 30)}
                          </a>
                        ) : "-"}
                      </td>
                      <td>
                        <span className="supplier-stock-table__notes">{supplier.notes || "-"}</span>
                      </td>
                      <td>
                        <div className="supplier-stock-table__owner">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tt-sup-${supplier._id}`}>{displayName}</Tooltip>}
                          >
                            <div
                              className="rounded-circle text-white d-flex align-items-center justify-content-center supplier-stock-table__owner-avatar"
                              style={{ backgroundColor: bgColor }}
                            >
                              {initial}
                            </div>
                          </OverlayTrigger>
                          <span className="supplier-stock-table__owner-name">{displayName}</span>
                        </div>
                      </td>
                      <td className="text-inline text-end">
                        <div className="supplier-stock-table__actions">
                          <Button className="ms-1" size="sm" variant="outline-secondary" title="Sửa" onClick={() => handleEdit(supplier)}>
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </Button>
                          <Button className="ms-1" size="sm" variant="outline-danger" title="Xoá" onClick={() => handleDelete(supplier._id)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6}>
                    <div className="supplier-stock-table__empty">
                      <i>Chưa có supplier nào trong workspace này.</i>
                    </div>
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </Table>
    </OverlayScrollbarsComponent>
  );
};

export default SupplierList;
